import React from 'react';

export default function WorkflowSVG() {
  return (
    <svg width="1050" height="490" viewBox="0 0 1050 490" style={{ maxWidth: '100%', height: 'auto' }}>
      <defs>
        <linearGradient id="wfBgGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#f0f9ff" />
          <stop offset="100%" stopColor="#e0f2fe" />
        </linearGradient>
        <linearGradient id="wfAiGlow" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#2563eb" />
          <stop offset="100%" stopColor="#1d4ed8" />
        </linearGradient>
        <linearGradient id="wfDocumentGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="100%" stopColor="#f1f5f9" />
        </linearGradient>
        <linearGradient id="wfEmailGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#fef3c7" />
          <stop offset="100%" stopColor="#fed7aa" />
        </linearGradient>
        <linearGradient id="wfFlowGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="transparent" />
          <stop offset="20%" stopColor="#2563eb" stopOpacity="0.8" />
          <stop offset="40%" stopColor="#60a5fa" stopOpacity="0.6" />
          <stop offset="60%" stopColor="#2563eb" stopOpacity="0.8" />
          <stop offset="100%" stopColor="transparent" />
          <animateTransform
            attributeName="gradientTransform"
            type="translate"
            values="0,0;100,0;0,0"
            dur="3s"
            repeatCount="indefinite"
          />
        </linearGradient>
        <linearGradient id="wfEmailPulse" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#f59e0b" stopOpacity="0.3" />
          <stop offset="100%" stopColor="#d97706" stopOpacity="0.6" />
          <animateTransform
            attributeName="gradientTransform"
            type="scale"
            values="1;1.1;1"
            dur="2s"
            repeatCount="indefinite"
          />
        </linearGradient>
        <clipPath id="wfCircleClip1"><circle cx="0" cy="0" r="45" /></clipPath>
        <clipPath id="wfCircleClip2"><circle cx="0" cy="0" r="45" /></clipPath>
        <clipPath id="wfCircleClip3"><circle cx="0" cy="0" r="45" /></clipPath>
      </defs>

      <rect width="1050" height="490" fill="url(#wfBgGradient)" rx="16" />

      {/* Title */}
      <text x="525" y="35" textAnchor="middle" fontSize="23" fontWeight="700" fill="#3b82f6">
        Documents in. Tasks out. Calendars synced
      </text>

      {/* Step 1: Email Documents In */}
      <g transform="translate(50, 70)">
        <text x="150" y="0" textAnchor="middle" fontSize="19" fontWeight="700" fill="#dc2626">Step 1: Email Documents</text>

        <rect x="10" y="15" width="320" height="60" fill="url(#wfEmailGradient)" stroke="#f59e0b" strokeWidth="3" rx="12" />
        <text x="170" y="40" textAnchor="middle" fontSize="18" fontWeight="600" fill="#92400e">
          <tspan fontSize="30" dy="1">📧</tspan>
          <tspan dx="5">Email to SmartClose</tspan>
        </text>
        <text x="170" y="65" textAnchor="middle" fontSize="16" fill="#92400e">Send your transaction documents</text>

        <g transform="translate(0, 85)">
          <g transform="translate(10, 0)">
            <rect x="0" y="0" width="155" height="80" fill="#dcfce7" stroke="#16a34a" strokeWidth="2" rx="8" />
            <text x="77.5" y="22" textAnchor="middle" fontSize="16" fontWeight="600" fill="#15803d">Agreements</text>
            <text x="77.5" y="65" textAnchor="middle" fontSize="45" fill="#16a34a">🏠</text>
          </g>
          <g transform="translate(175, 0)">
            <rect x="0" y="0" width="155" height="80" fill="#fef3c7" stroke="#f59e0b" strokeWidth="2" rx="8" />
            <text x="77.5" y="22" textAnchor="middle" fontSize="16" fontWeight="600" fill="#92400e">Schedules</text>
            <text x="77.5" y="65" textAnchor="middle" fontSize="45" fill="#f59e0b">📋</text>
          </g>
          <g transform="translate(10, 90)">
            <rect x="0" y="0" width="155" height="80" fill="#fce7f3" stroke="#ec4899" strokeWidth="2" rx="8" />
            <text x="77.5" y="22" textAnchor="middle" fontSize="16" fontWeight="600" fill="#be185d">Inspection Reports</text>
            <text x="77.5" y="65" textAnchor="middle" fontSize="45" fill="#ec4899">🔍</text>
          </g>
          <g transform="translate(175, 90)">
            <rect x="0" y="0" width="155" height="80" fill="#ede9fe" stroke="#8b5cf6" strokeWidth="2" rx="8" />
            <text x="77.5" y="22" textAnchor="middle" fontSize="16" fontWeight="600" fill="#7c3aed">Financing Docs</text>
            <text x="77.5" y="65" textAnchor="middle" fontSize="45" fill="#8b5cf6">💰</text>
          </g>
        </g>
      </g>

      {/* AI Processing Flow */}
      <g>
        <path d="M 370 140 Q 450 100 530 140" stroke="#f59e0b" strokeWidth="8" fill="none" strokeDasharray="12,8">
          <animate attributeName="stroke-dashoffset" values="20;0" dur="2s" repeatCount="indefinite" />
        </path>
        <text fontSize="42" fill="#f59e0b">
          <animateMotion dur="3s" repeatCount="indefinite" rotate="auto">
            <mpath xlinkHref="#wfEmailPath" />
          </animateMotion>
          📧
        </text>
        <path id="wfEmailPath" d="M 370 140 Q 450 100 530 140" fill="none" />
      </g>

      {/* Step 2: SmartClose AI */}
      <g transform="translate(525, 120)">
        <text x="0" y="-40" textAnchor="middle" fontSize="19" fontWeight="700" fill="#2563eb">Step 2: AI Analysis</text>
        <circle cx="0" cy="45" r="80" fill="url(#wfAiGlow)" opacity="0.15" />
        <circle cx="0" cy="45" r="70" fill="url(#wfAiGlow)" />
        <rect x="-60" y="20" width="120" height="55" fill="white" rx="8" />
        <text x="0" y="45" textAnchor="middle" fontSize="20" fontWeight="700" fill="#2563eb">SmartClose</text>
        <text x="0" y="70" textAnchor="middle" fontSize="20" fontWeight="700" fill="#2563eb">AI</text>
        <g opacity="0.9">
          <circle cx="-60" cy="0" r="5" fill="#60a5fa">
            <animate attributeName="cy" values="0;20;0" dur="2s" repeatCount="indefinite" />
          </circle>
          <circle cx="60" cy="10" r="5" fill="#34d399">
            <animate attributeName="cy" values="10;30;10" dur="1.8s" repeatCount="indefinite" />
          </circle>
          <circle cx="-35" cy="80" r="5" fill="#fbbf24">
            <animate attributeName="cy" values="80;50;80" dur="2.2s" repeatCount="indefinite" />
          </circle>
          <circle cx="35" cy="-10" r="5" fill="#f87171">
            <animate attributeName="cy" values="-10;10;-10" dur="1.6s" repeatCount="indefinite" />
          </circle>
        </g>
        <text x="0" y="150" textAnchor="middle" fontSize="16" fontWeight="600" fill="#374151">Multi-Document Intelligence</text>
        <text x="0" y="168" textAnchor="middle" fontSize="14" fill="#6b7280">Property • Client • Timeline Recognition</text>
      </g>

      {/* Output Flow Animation */}
      <g>
        <path d="M 590 140 Q 650 100 720 140" stroke="#22c55e" strokeWidth="8" fill="none" strokeDasharray="12,8">
          <animate attributeName="stroke-dashoffset" values="20;0" dur="2s" repeatCount="indefinite" />
        </path>
        <text fontSize="30" fill="#22c55e">
          <animateMotion dur="3s" repeatCount="indefinite" rotate="auto">
            <mpath xlinkHref="#wfOutputPath" />
          </animateMotion>
          📅
        </text>
        <path id="wfOutputPath" d="M 590 140 Q 650 100 720 140" fill="none" />
      </g>

      {/* Step 3: Smart Automation */}
      <g transform="translate(660, 70)">
        <text x="140" y="0" textAnchor="middle" fontSize="19" fontWeight="700" fill="#059669">Step 3: Smart Automation</text>

        <rect x="10" y="15" width="320" height="60" fill="#dcfce7" stroke="#16a34a" strokeWidth="3" rx="12" />
        <text x="170" y="40" textAnchor="middle" fontSize="18" fontWeight="600" fill="#15803d">📅 Calendar Integration</text>
        <text x="170" y="65" textAnchor="middle" fontSize="16" fill="#15803d">Google • Outlook • Apple sync</text>

        <g transform="translate(0, 85)">
          <g transform="translate(10, 0)">
            <rect x="0" y="0" width="155" height="80" fill="#dbeafe" stroke="#3b82f6" strokeWidth="2" rx="8" />
            <text x="77.5" y="20" textAnchor="middle" fontSize="16" fontWeight="600" fill="#1e40af">Auto Tasks</text>
            <text x="10" y="38" fontSize="13" fill="#1e40af">✓ Schedule Inspection</text>
            <text x="10" y="53" fontSize="13" fill="#1e40af">✓ Review Financing</text>
            <text x="10" y="68" fontSize="13" fill="#1e40af">✓ Prepare Closing</text>
          </g>
          <g transform="translate(175, 0)">
            <rect x="0" y="0" width="155" height="80" fill="#f3e8ff" stroke="#8b5cf6" strokeWidth="2" rx="8" />
            <text x="77.5" y="20" textAnchor="middle" fontSize="16" fontWeight="600" fill="#7c3aed">Auto Events</text>
            <text x="10" y="38" fontSize="13" fill="#7c3aed">📅 Inspection: Mon 2pm</text>
            <text x="10" y="53" fontSize="13" fill="#7c3aed">📅 Appraisal: Wed 10am</text>
            <text x="10" y="68" fontSize="13" fill="#7c3aed">📅 Closing: Fri 3pm</text>
          </g>
          <g transform="translate(10, 90)">
            <rect x="0" y="0" width="155" height="80" fill="#fef3c7" stroke="#f59e0b" strokeWidth="2" rx="8" />
            <text x="77.5" y="20" textAnchor="middle" fontSize="16" fontWeight="600" fill="#92400e">Updates</text>
            <text x="10" y="38" fontSize="15" fill="#92400e">📧 Email replies</text>
            <text x="10" y="53" fontSize="13" fill="#92400e">📞 Phone changes</text>
            <text x="10" y="68" fontSize="13" fill="#92400e">⚡ Real-time sync</text>
          </g>
          <g transform="translate(175, 90)">
            <rect x="0" y="0" width="155" height="80" fill="#fce7f3" stroke="#ec4899" strokeWidth="2" rx="8" />
            <text x="77.5" y="20" textAnchor="middle" fontSize="16" fontWeight="600" fill="#be185d">Team Sync</text>
            <text x="10" y="38" fontSize="13" fill="#be185d">👥 Agent alignment</text>
            <text x="10" y="53" fontSize="13" fill="#be185d">👨‍💼 Assistant sync</text>
            <text x="10" y="68" fontSize="13" fill="#be185d">🔄 Multi-property</text>
          </g>
        </g>
      </g>

      {/* Key Features */}
      <g transform="translate(50, 360)">
        <text x="0" y="0" fontSize="17" fontWeight="600" fill="#2563eb">SmartClose Features</text>
        <line x1="0" y1="6" x2="160" y2="6" stroke="#2563eb" strokeWidth="3" />
        <text x="0" y="28" fontSize="15" fill="#059669">🏠 Property Recognition</text>
        <text x="0" y="50" fontSize="15" fill="#0369a1">📧 Document AI Processing</text>
        <text x="0" y="72" fontSize="15" fill="#7c2d12">📱 Phone &amp; Email Updates</text>
        <text x="0" y="94" fontSize="15" fill="#6b21a8">🔄 Multi-Platform Sync</text>
        <text x="0" y="116" fontSize="15" fill="#dc2626">⚡ Next-Gen AI Tasking</text>
      </g>
    </svg>
  );
}
